
    import { computed, defineComponent, type PropType } from 'vue'
    import { useRoute } from 'vue-router/composables'

    import { post } from '@/common/json-ld/posts'
    import type { Post } from '@/common/models/data/dashboard/posts/post'
    import type { PostSocialLinks } from '@/common/models/data/dashboard/posts/post-social-links'

    import Gallery from '@/app/components/common/posts/Gallery.vue'
    import PostContent from '@/app/components/common/posts/PostContent.vue'
    import PostFooter from '@/app/components/common/posts/PostFooter.vue'
    import PostHeader from '@/app/components/common/posts/PostHeader.vue'
    import PostSnapshot from '@/app/components/common/posts/PostSnapshot.vue'
    import PostStaffEntry from '@/app/components/common/posts/PostStaffEntry.vue'

    export default defineComponent({
        components: {
            Gallery,
            PostContent,
            PostFooter,
            PostHeader,
            PostSnapshot,
            PostStaffEntry
        },
        props: {
            post: {
                type: Object as PropType<Post>,
                required: true
            },
            similar: {
                type: Array as PropType<Array<Post>>,
                required: true
            },
            shares: {
                type: Object as PropType<PostSocialLinks>,
                required: true
            }
        },
        setup (props) {
            const route = useRoute()

            return {
                jsonLd: computed(() => post(props.post, route.path))
            }
        }
    })
